import { Compass } from 'lucide-react';
import { Link } from 'react-router';
import { useScope } from '../scope/scope';
import { buttonClass } from '../ui/Button';
import { Card, EmptyState } from '../ui/misc';

export function NotFoundPage() {
  const { mspId } = useScope();
  return (
    <Card><EmptyState icon={<Compass className="size-5" />} title="This page doesn’t exist" action={<Link to={`/w/${mspId}/today`} className={buttonClass('primary')}>Go to Today</Link>}>
      Check the link, or search for what you need with the search bar.
    </EmptyState></Card>
  );
}
